import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentCancel.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    navigate('/pricing');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="payment-cancel-container">
      <div className="payment-cancel-content">
        <div className="cancel-icon">❌</div>
        <h2>Payment Canceled</h2>
        <p>Your payment was canceled. No charges have been made to your account.</p>
        
        <div className="cancel-details">
          <h3>What happened?</h3>
          <ul>
            <li>You may have closed the payment window</li>
            <li>There might have been an issue with your payment method</li>
            <li>You decided not to complete the purchase</li>
          </ul>
        </div>

        <div className="cancel-actions">
          <button onClick={handleTryAgain} className="try-again-button">
            Try Again
          </button>
          <button onClick={handleGoHome} className="home-button">
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
